import script from "./AdBannerView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdBannerView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__